import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { useState as f } from "react";
import { Stack as r, Box as y, Collapse as g } from "@mui/material";
import { Typography as i } from "./index59.mjs";
import { Switch as u } from "./index65.mjs";
import { ExpandMoreRounded as w } from "@mui/icons-material";
import { messages as C } from "./messages4.mjs";
const b = (c) => {
  const { title: a, description: s, value: d, isAlwaysActive: l, locale: p, onChange: m } = c, [n, h] = f(!1);
  return /* @__PURE__ */ t(r, { children: [
    /* @__PURE__ */ t(
      r,
      {
        flexGrow: 1,
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingY: 1.5,
        sx: { cursor: "pointer" },
        onClick: () => h((e) => !e),
        children: [
          /* @__PURE__ */ t(r, { direction: "row", gap: 1.25, children: [
            /* @__PURE__ */ o(
              w,
              {
                sx: { transform: n ? "rotate(180deg)" : void 0 }
              }
            ),
            /* @__PURE__ */ o(i.H5, { color: (e) => e.palette.text.primary, children: a })
          ] }),
          /* @__PURE__ */ o(y, { children: l ? /* @__PURE__ */ o(i.Body2, { color: (e) => e.palette.text.secondary, children: C.alwaysActive[p] }) : /* @__PURE__ */ o(
            u,
            {
              checked: d,
              onClick: (e) => e.stopPropagation(),
              onChange: (e, x) => m?.(x)
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ o(g, { in: n, timeout: "auto", children: /* @__PURE__ */ o(i.Body2, { color: (e) => e.palette.text.body, children: s }) })
  ] });
};
export {
  b as CookieSection
};
//# sourceMappingURL=index327.mjs.map
